import {post} from '../../common/utils/FetchUtils';

export async function loginOperator(username, password) {
  return post('/api/Authentication/login', {username, password, rememberMe: true});
}

export async function logoutOperator() {
  return post('/api/Authentication/logout', {});
}
